const styles = theme => ({
  carouselViewButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginLeft: 6,
    //backgroundColor: '#015FFB',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  mobileViewForFinishScreen: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  nonMobileViewForFinishScreen: {
    display: 'flex',
    marginTop: '40px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  redirectCards: {
    borderRadius: 16,
    marginBottom: 16,
    padding: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  gatewayTooltipStyle: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  gatewayTooltipStylePc: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
})

export default styles
